import React from 'react';
import { t } from '../../../../../locales';
import './styles.scss';

const SeeAllNewsButton = (props: { title: string; deepLink: string }) => {
  const { title, deepLink } = props;
  return (
    <div className="show-all-news-btn-wrapper">
      <a
        href={deepLink}
        target="_blank"
        data-enable-ga
        data-ga-type="link"
        rel="noreferrer"
      >
        <button type="button" className="emma-stylesheet-primary-ghost-button">
          {t(title)}
        </button>
      </a>
    </div>
  );
};

export default SeeAllNewsButton;
